// ** Navigation imports
import home from "./home";
import leaveSystem from "./leaveSystem";
import flexTimeSystem from "./flexTimeSystem";
import timeRecord from "./timeRecord";
import m75 from "./m75";

// ** Merge & Export
export default [
  ...home,
  // ...apps,
  ...leaveSystem,
  ...flexTimeSystem,
  ...timeRecord,
  ...m75,
  // ...dashboards,
  // ...pages,
  // ...uiElements,
  // ...forms,
  // ...tables,
  // ...charts,
  // ...others
];
